import { StepLayout } from '@/components/NewGeneralDialog/StepLayout';
import { WizardAnimationWrapper } from '@/components/WizardAnimationWrapper';
import { Documents } from '@/types/company';
import { Box, Button, Typography } from '@mui/material';
import { ArrowRightIcon } from '@mui/x-date-pickers';
import { toSentenceCase } from '@treyd-io/core/utils/string';
import { useTranslation } from 'react-i18next';

interface GuaranteeDocumentProps {
  document?: Documents.DocumentType;
  handleNextStep: (step?: number) => void;
  next: boolean;
}
export const GuaranteeDocument = ({
  document,
  next,
  handleNextStep,
}: GuaranteeDocumentProps) => {
  const { t } = useTranslation();

  return (
    <WizardAnimationWrapper next={next} firstStep>
      <StepLayout
        layoutProps={{
          marginX: { xs: 0 },
        }}>
        <Box width={'100%'}>
          <Typography variant={'h3'} color="text.primary" marginBottom={4}>
            {toSentenceCase(document?.title?.toLowerCase() || '')}
          </Typography>
          {document?.pdf_url && (
            <iframe
              src={document?.pdf_url}
              title={toSentenceCase(document?.title?.toLowerCase() || '')}
              style={{ width: '100%', height: '100vh' }}
            />
          )}
          <Button
            variant="contained"
            color="primary"
            size="large"
            endIcon={<ArrowRightIcon />}
            sx={{
              marginTop: 4,
              width: { xs: '100%', sm: 'auto' },
            }}
            onClick={() => handleNextStep()}>
            {t('review_and_sign')}
          </Button>
        </Box>
      </StepLayout>
    </WizardAnimationWrapper>
  );
};
